import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";

const ACTION_STYLE = {
  login: "bg-navy/10 text-navy",
  publish: "bg-green-100 text-green-700",
  submit_review: "bg-gold/20 text-navy",
  approve: "bg-green-100 text-green-700",
  reject: "bg-red-100 text-red-600",
  rollback: "bg-blue-100 text-blue-700",
  user_create: "bg-purple-100 text-purple-700",
  user_update: "bg-purple-100 text-purple-700",
  user_delete: "bg-red-100 text-red-600",
  password_change: "bg-purple-100 text-purple-700",
};

export const AuditPanel = () => {
  const [log, setLog] = useState([]);
  useEffect(() => { api.get("/admin/audit").then((r) => setLog(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="audit-panel">
      <p className="text-navy/60 text-sm mb-6">A record of every action taken in the admin area, and who made it.</p>
      <div className="bg-white border border-navy/10 divide-y divide-navy/10">
        {log.length === 0 && <p className="p-5 text-navy/50">No activity recorded yet.</p>}
        {log.map((a) => (
          <div key={a.id} className="p-4 flex flex-wrap items-center gap-3" data-testid="audit-item">
            <span className={`text-xs font-semibold px-2 py-1 rounded-sm ${ACTION_STYLE[a.action] || "bg-navy/10 text-navy"}`}>{a.action}</span>
            <span className="text-navy font-medium">{a.user_email}</span>
            <span className="text-navy/60 text-sm flex-1">{a.detail}</span>
            <span className="text-xs text-navy/40">{new Date(a.created_at).toLocaleString()}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
